module.exports = __webpack_public_path__ + "static/media/process-market.3c654393.svg";